/* eslint-disable compat/compat */

function copyText(text: string) {
  navigator.clipboard.writeText(text);
}

export default copyText;
